import { FC } from 'react'
import { Box, DarkMode } from '@chakra-ui/react'
import { AdTitle, ChronicleFixInfoWrapper, InfoBtn } from './styled'

interface IChronicleFIXInfo {}

export const ChronicleFIXInfo: FC<IChronicleFIXInfo> = () => {
    const handleOpenUrl = (url: string) => () => window.open(url, '_blank')

    return (
        <ChronicleFixInfoWrapper>
                <Box bg="#1E252B" textAlign="center" maxWidth={600} p={14}>
                    <AdTitle>Want To Try Chronicle FIX?</AdTitle>
                    <Box mb={8} fontSize="18px">
                        Experience a <span style={{ fontWeight: '500', color: '#E29633' }}>98% latency reduction</span>{' '}
                        compared to QuickFIX at 99.9% percentile{' '}
                    </Box>
                    <Box my={3}>
                        <DarkMode>
                        <InfoBtn 
                            mx={3}
                            borderRadius={2}
                            onClick={handleOpenUrl('https://chronicle.software/products/fix-engine/')}
                            _hover={{
                                background: "chronicle.ultramarineLight",
                                color: 'white'
                            }}
                        >
                            Learn More
                        </InfoBtn>
                        <InfoBtn
                            mx={3}
                            borderRadius={2}
                            onClick={handleOpenUrl('https://chronicle.software/demo?product=fix')}
                            _hover={{
                                background: "chronicle.ultramarineLight",
                                color: 'white'
                            }}
                        >
                            Try the Demos
                        </InfoBtn>
                        </DarkMode>
                    </Box>
                </Box>
        </ChronicleFixInfoWrapper>
    )
}
